import { groupSurplusOthers } from "./groupSurplusOthers"

export const splitOthersForDisplay = <TItem, TSplit>({
  others,
  totalDisplay,
  featuredCount,
  sortItem,
  mapToSplit,
  buildOthersSplit,
  maxOthersInTooltip,
}: {
  others: TItem[]
  totalDisplay: number
  featuredCount: number
  sortItem: (a: TItem, b: TItem) => number
  mapToSplit: (item: TItem) => TSplit
  buildOthersSplit: (rest: TItem[], restToGroup: TItem[]) => TSplit
  maxOthersInTooltip: number
}): TSplit[] => {
  const sortedOthers = [...others].sort(sortItem)

  const visibleCount = Math.max(totalDisplay - 1 - featuredCount, 0)

  const visibleSplits = sortedOthers.slice(0, visibleCount).map(mapToSplit)

  const surplus = sortedOthers.slice(visibleCount)

  return [
    ...visibleSplits,
    ...groupSurplusOthers({
      surplus,
      mapToSplit,
      buildOthersSplit,
      maxOthersInTooltip,
    }),
  ]
}
